module.exports = __webpack_public_path__ + "img/vuexy-logo.ee22d58f.png";